export default __webpack_public_path__ + "static/media/loginImg.ad0ababe.svg";